import { Navigate, Outlet } from "react-router-dom";

export default function ProtectedRoute() {
  const session = localStorage.getItem("userSessionData");

  const user = session ? JSON.parse(session) : null;

  return user ? <Outlet /> : <Navigate to="/" replace />;
}
